import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import SectionHeader from './section-header'
import SelectInput from '../inputs/select-input'
import DateInput from '../inputs/date-input'
import FlashAlert from '../../flash-alert'

function DateTimeSection(props) {
  const { step, selectedSize, selectedDate, onSelectDate, selectedDuration, isLoading, 
    intervals, selectedInterval, alert } = props
  const durationOptions = [[1, '1 Hour'], [1.5, '1.5 Hours'], [2, '2 Hours']]

  useEffect(() => {
    fetchTimeIntervals()
  }, [selectedSize, selectedDate, selectedDuration])

  useEffect(() => {
    if (!_.isEmpty(selectedInterval)) fetchFieldPrice()
  }, [selectedInterval])

  const fetchTimeIntervals = () => {
    const params = {
      size: selectedSize,
      date: selectedDate.format('YYYY-MM-DD'),
      duration: selectedDuration
    }
    props.fetchIntervals(params)
  }

  const fetchFieldPrice = () => {
    const params = {
      size: selectedSize,
      date: selectedDate.format('YYYY-MM-DD'),
      duration: selectedDuration,
      time: selectedInterval.value
    }
    props.fetchPrice(params)
  }

  const addIntervals = () => {
    if (!intervals.length) return

    const rowSize = Math.ceil(intervals.length / 5)
    const chunks = _.chunk(intervals, rowSize)
    return chunks.map((row, i) => addIntervalsRow(row, i) )
  }

  const addIntervalsRow = (row, index) => {
    return <div className='time-intervals__row' key={index}>{ row.map((e, i) => addIntervalCell(e, i)) }</div>
  }

  const addIntervalCell = (interval, index) => {
    var classes = ['time-intervals__row__cell']
    const disabled = interval.booked || interval.past
    const selected = interval == selectedInterval
    if (selected) classes.push('selected')
    if (disabled) classes.push('disabled')

    return <div 
      className={classes.join(' ')}
      key={index}
      onClick={() => !disabled && !selected && props.selectInterval(interval)}
    >
      {interval.text}
    </div>
  }

  return <div className='times'>
    <SectionHeader title='SELECT TIME' />
    { step == 'time' && isLoading && <div className='animated-spinner'></div> }
    { step == 'time' && alert &&
      <FlashAlert text={alert.text} type={alert.type} onHide={() => props.setAlert(null)} />
    }
    { step == 'time' &&
      <div className={`date-time ${isLoading ? ' isLoading' : ''}`}>
        <div className='desktop-only'>
          <DatePicker inline fixedHeight onChange={onSelectDate} selected={selectedDate} />
        </div>
        <div className='date-time__time'>
          <div className='datepicker-mobile mobile-only'>
            <DatePicker
              customInput={<DateInput />}
              onChange={onSelectDate}
              selected={selectedDate}
            />
          </div>
          <SelectInput
            name='booking-duration'
            options={durationOptions}
            value={selectedDuration}
            onChange={e => props.onSelectDuration(e.target.value)}
          />
          <div className='date-time__time__list'>
            <div className='time-intervals'>
              { addIntervals() }
            </div>
          </div>
          <div className='navigation-buttons desktop-only'>
            <button className='btn btn-next' onClick={props.onNextStep}>Next</button>
            <button className='btn btn-back' onClick={props.onPrevStep}>Back</button>
          </div>
        </div>
      </div>
    }
  </div>
}

DateTimeSection.propTypes = {
  step: PropTypes.string.isRequired,
  alert: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  selectedDate: PropTypes.object.isRequired,
  selectedSize: PropTypes.string.isRequired,
  selectedDuration: PropTypes.string.isRequired,
  selectedInterval: PropTypes.object.isRequired,
  intervals: PropTypes.array.isRequired,
  onSelectDate: PropTypes.func.isRequired,
  onSelectDuration: PropTypes.func.isRequired,
  fetchIntervals: PropTypes.func.isRequired,
  fetchPrice: PropTypes.func.isRequired,
  selectInterval: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
  onNextStep: PropTypes.func.isRequired,
  onPrevStep: PropTypes.func.isRequired,
}

export default DateTimeSection
